import { FormHelperText, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface Props {
  maximumLength: number;
  reservedDigits: number;
  inputMaxLength: number;
}

export function ArticleNumberAllowance({
  maximumLength,
  reservedDigits,
  inputMaxLength,
}: Props) {
  const { t } = useTranslation();
  return (
    <FormHelperText>
      <Text>
        {t('article.create.totalItemCodeLength', { count: maximumLength })}
      </Text>
      <Text>
        {t('article.create.numberingDigitsReserved', { count: reservedDigits })}
      </Text>
      <Text>
        {t('article.create.itemCodeCharactersAvailable', {
          count: inputMaxLength,
        })}
      </Text>
    </FormHelperText>
  );
}
